const TreeFilter = () => import("@/components/common/tree/Filter");
export default {
	components: {
		TreeFilter
	},
	props: {
		// 源数据
		treeData: {
			type: Array,
			default: function() {
				return [];
			},
		},

		// 树节点是否默认展开
		treeExpandAll: {
			type: Boolean,
			default: true,
		},

		// 树节点唯一标识
		treeNodeKey: {
			type: String,
			default: "",
		},
	},
	data() {
		return {
			defaultProps: {
				children: "children",
				label: "text",
			},
			selectItem: {},
		};
	},
	methods: {
		handleNodeClick(data) {
			//alert(1)
			//console.log(JSON.parse(JSON.stringify(data)));
			//this.$parent.$parent.monitorNodeClick(data);
		},
		showInfo(node,data) {
			this.$emit("showMonitorData",data); //刷新树
			//console.log(123456);
			//console.log(node);
			//console.log(node.parent.childNodes);
			//console.log(node.parent.childNodes);
		},
		filterNode(value, data) {
			if (!value) return true;
			return data.text.indexOf(value) !== -1;
		},
		// showInfoBtnOrNot(data){
		// 	if(data.children.length>0||(data?.monitorItemDto&&data.monitorItemDto.typeName==='线型监测')){
				
		// 	}else{
		// 		return false;
		// 	}
		// },
		showInfoBtnOrNot:function(data){
			if(data.children.length<=0||(data?.monitorItemDto&&data.monitorItemDto.typeName=='线型监测')){
				return false;
			}else{
				return true;
			}
		}
	},
};
